import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=47cdd254&scoped=true&"
import script from "./FaqSection.vue?vue&type=script&lang=js&"
export * from "./FaqSection.vue?vue&type=script&lang=js&"
import style0 from "./FaqSection.vue?vue&type=style&index=0&id=47cdd254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cdd254",
  null
  
)

export default component.exports